import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import UserInput from 'components/custom/UserInputSelection/index'
import InputWrapper from 'components/custom/InputWrapper'
import Dropdown from 'components/fulcrum/dropdown/FulcrumDropdown'


import {
  fetchEmployeeListWithImages as fetchEmployeeList,
} from 'containers/User/actions'

import {
  updateAeRegion
} from 'containers/Admin/PartnerSite/PartnerSiteAddDialog/actions'

import {
  employeeListWithImageValues as employeeListSelector,
  isLoadingEmployeeList,
} from 'containers/User/selectors'

import {
  aeRegionSelector,
  aeRegionListSelector,
} from 'containers/Admin/PartnerSite/PartnerSiteAddDialog/selectors'

import {
  TEAM_ENUM
} from './constants'
import {
  updateSiteRolesChange,
} from './actions'

import {
  aeSelector,
  aemSelector,
  cpmSelector,
  amSelector,
  faeSelector,
  cpdSelector,
  spmSelector,
  obsSelector,
} from './selectors'

const mapStateToProps = (state) => {
  return {
    aeSource: aeSelector(state),
    cpmSource: cpmSelector(state),
    aemSource: aemSelector(state),
    amSource: amSelector(state),
    faeSource: faeSelector(state),
    cpdSource: cpdSelector(state),
    spmSource: spmSelector(state),
    obsSource: obsSelector(state),
    aeRegionSource: aeRegionSelector(state),
    aeRegionListSource: aeRegionListSelector(state),
    employeeList: employeeListSelector(state),
    isLoading: isLoadingEmployeeList(state),
  }
}

const mapDispatchToProps = (dispatch) => {
  const addRoleToUsers = role => R.map(user => ({ role, ...user }))

  return {
    fetchEmployeeList: (query) => dispatch(fetchEmployeeList(query)),
    onAeChange: (team) => dispatch(updateSiteRolesChange(
      addRoleToUsers(TEAM_ENUM.ACCOUNT_APPLICATIONS_ENGINEER)(team),
      TEAM_ENUM.ACCOUNT_APPLICATIONS_ENGINEER
    )),
    onCpmChange: (team) => dispatch(updateSiteRolesChange(
      addRoleToUsers(TEAM_ENUM.CUSTOMER_PROGRAM_MANAGER)(team),
      TEAM_ENUM.CUSTOMER_PROGRAM_MANAGER
    )),
    onAemChange: (team) => dispatch(updateSiteRolesChange(
      addRoleToUsers(TEAM_ENUM.APPLICATIONS_ENGINEERING_MANAGER)(team),
      TEAM_ENUM.APPLICATIONS_ENGINEERING_MANAGER
    )),
    onAmChange: (team) => dispatch(updateSiteRolesChange(
      addRoleToUsers(TEAM_ENUM.ACCOUNT_MANAGER)(team),
      TEAM_ENUM.ACCOUNT_MANAGER
    )),
    onFaeChange: (team) => dispatch(updateSiteRolesChange(
      addRoleToUsers(TEAM_ENUM.FIELD_APPLICATIONS_ENGINEER)(team),
      TEAM_ENUM.FIELD_APPLICATIONS_ENGINEER
    )),
    onCpdChange: (team) => dispatch(updateSiteRolesChange(
      addRoleToUsers(TEAM_ENUM.CUSTOMER_PROGRAM_DIRECTOR)(team),
      TEAM_ENUM.CUSTOMER_PROGRAM_DIRECTOR
    )),
    onSpmChange: (team) => dispatch(updateSiteRolesChange(
      addRoleToUsers(TEAM_ENUM.SOFTWARE_PROGRAM_MANAGER)(team),
      TEAM_ENUM.SOFTWARE_PROGRAM_MANAGER
    )),
    onObsChange: (team) => dispatch(updateSiteRolesChange(
      addRoleToUsers(TEAM_ENUM.OBSERVER)(team),
      TEAM_ENUM.OBSERVER
    )),
    onAeRegionChange: (newAeRegion) => dispatch(updateAeRegion(newAeRegion)),
  }
}

class PartnerSiteTeam extends Component {
  render() {
    const {
      aeSource,
      aemSource,
      cpmSource,
      faeSource,
      amSource,
      cpdSource,
      spmSource,
      obsSource,
      aeRegionSource,
      employeeList,
      aeRegionListSource,
      fetchEmployeeList,
      onAeChange,
      onCpmChange,
      onAemChange,
      onFaeChange,
      onAmChange,
      onCpdChange,
      onSpmChange,
      onObsChange,
      onAeRegionChange,
      isLoading,
      includeAeRegion,
    } = this.props

    return (
      <React.Fragment>
        {includeAeRegion &&
          <InputWrapper
            label={"AE Region"}
            mandatory
          >
            <Dropdown
              hint={"Select Region"}
              source={aeRegionListSource}
              value={aeRegionSource}
              onChange={onAeRegionChange}
            />
          </InputWrapper>
        }
        <UserInput
          multi
          label='Customer Program Manager'
          options={employeeList}
          onInputChange={fetchEmployeeList}
          onChange={onCpmChange}
          value={cpmSource}
          isLoading={isLoading}
        />
        <UserInput
          multi
          label='Account Appplications Engineer'
          options={employeeList}
          onInputChange={fetchEmployeeList}
          onChange={onAeChange}
          value={aeSource}
          isLoading={isLoading}
        />
        <UserInput
          multi
          label='Field Applications Engineer'
          options={employeeList}
          onInputChange={fetchEmployeeList}
          onChange={onFaeChange}
          value={faeSource}
          isLoading={isLoading}
        />
        <UserInput
          multi
          label='Applications Engineering Manager'
          options={employeeList}
          onInputChange={fetchEmployeeList}
          onChange={onAemChange}
          value={aemSource}
          isLoading={isLoading}
        />
        <UserInput
          multi
          label='Account Manager'
          options={employeeList}
          onInputChange={fetchEmployeeList}
          onChange={onAmChange}
          value={amSource}
          isLoading={isLoading}
        />
        <UserInput
          multi
          label='Customer Program Director'
          options={employeeList}
          onInputChange={fetchEmployeeList}
          onChange={onCpdChange}
          value={cpdSource}
          isLoading={isLoading}
        />
        <UserInput
          multi
          label='Software Program Manager'
          options={employeeList}
          onInputChange={fetchEmployeeList}
          onChange={onSpmChange}
          value={spmSource}
          isLoading={isLoading}
        />
        <UserInput
          multi
          label='Observer'
          options={employeeList}
          onInputChange={fetchEmployeeList}
          onChange={onObsChange}
          value={obsSource}
          isLoading={isLoading}
        />
      </React.Fragment>
    )
  }
}

const withConnect = connect(mapStateToProps, mapDispatchToProps)

export default compose(
  withConnect,
)(PartnerSiteTeam)
